<template>
  <artmisads-modal
    v-model:open="configs.open"
    @ok="onOk"
    @cancel="onModalCancel"
    style="width: 720px"
    :ok-text="
      configs.type == 'single'
        ? $t('seller.scheduledTaskModal.yesCancel')
        : $t('seller.scheduledTaskModal.confirm')
    "
    :cancel-text="
      configs.type == 'single'
        ? $t('seller.scheduledTaskModal.noKeep')
        : $t('seller.scheduledTaskModal.cancel')
    "
  >
    <template #title>
      <Icon name="a-warring-tianchong3" class="icon-style" />
      <span style="padding-left: 10px">{{
        $t('seller.scheduledTaskModal.title')
      }}</span>
    </template>
    <div class="content">
      <span v-if="configs.type == 'single'">{{
        $t('seller.scheduledTaskModal.confirmCancelSingle')
      }}</span>
      <p v-else>
        {{ $t('seller.scheduledTaskModal.confirmBulkPart1') }}
        {{
          configs.modalType == 'active'
            ? $t('seller.scheduledTaskModal.verbActivate')
            : $t('seller.scheduledTaskModal.verbDeactivate')
        }}
        <span class="boldBlack">{{ configs.productCountInfo }}</span>
        {{ $t('seller.scheduledTaskModal.productsQuestion') }}
        <span class="boldBlack">{{
          $t('seller.scheduledTaskModal.effectiveTime', { time: timeYYYY })
        }}</span>
      </p>
    </div>
    <div class="bottom-content" v-if="configs.type == 'single'">
      <Icon name="info-tianchong" class="tianchong" />
      <div>
        <p class="paragraph">
          {{
            $t('seller.scheduledTaskModal.statusScheduledLine', {
              status:
                configs.modalType == 'active'
                  ? $t('seller.common.inactive')
                  : $t('seller.common.active'),
              date: item.timeMonthNameAll,
            })
          }}
        </p>
        <p class="paragraph" style="margin: 10px 0">
          {{ $t('seller.scheduledTaskModal.scheduledPerPreviousSettings') }}
        </p>
      </div>
    </div>
  </artmisads-modal>
</template>
<script setup name="suerModal">
import { ref, watch } from 'vue'
import Icon from '@/components/Icon.vue'
import { productsApi, brandApi } from '@/server/index'
const emit = defineEmits(['cancel', 'ok'])
import moment from 'moment'
import { useUserInfoStore } from '@/storeData'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'

const user = useUserInfoStore()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]
const time = ref('')
const timeYYYY = ref('')

const { configs, item } = defineProps({
  configs: {
    type: Object,
    default: () => {},
  },
  item: {
    type: Object,
    default: () => {},
  },
})
watch(
  () => configs.modalType,
  (newVal, oldVal) => {
    
    if (newVal) {
      let nextWorkingDay = moment().tz(timezone)
      let workingDaysCount = 0
      if (newVal == 'active') {
        // Calculate next working day (Monday-Friday)
        while (workingDaysCount < 1) {
          nextWorkingDay = nextWorkingDay.add(1, 'day')
          if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
            workingDaysCount++
          }
        }
      } else {
        while (workingDaysCount < 4) {
          nextWorkingDay = nextWorkingDay.add(1, 'day')
          if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
            workingDaysCount++
          }
        }
      }
      timeYYYY.value = nextWorkingDay.format('YYYY-MM-DD')
      //  timeYYYY.value = moment(newVal?.displayTime)
      //           .tz(timezone)
      //           .format('YYYY')
    }
  },
  { deep: true,immediate: true },
)
// watch(()=>item, (newVal, oldVal) => {
//  if(newVal){
//   console.log(newVal,'newVal?.displayTime')
//   time.value = moment(newVal?.displayTime)
//             .tz(timezone)
//             .format('MMMM DD,YYYY')

//  }

// }, {deep: true})
const onOk = async () => {
  //   const data = await brandApi.cancelTask({
  //   operationId: item.statusChangeOperations[0].operationId,
  // })
  // if (data.success) {
  //   message.success('Cancel Success！', 1)

  //  emit('ok', item)
  // }
  emit('ok', item)
}
const onModalCancel = () => {
  emit('cancel', item)
}
</script>
<style lang="less" scoped>
.icon-style {
  fill: rgba(245, 155, 0, 1);
  font-size: 20px;

  // margin-bottom: 10px;
}

.content {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  color: rgba(15, 6, 41, 1);
}
.boldBlack {
  font-family: Sora;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
}
.bottom-content {
  border-radius: 8px;
  background-color: rgba(80, 64, 128, 0.08);
  padding: 10px;
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.tianchong {
  color: rgba(131, 92, 242, 1);
  width: 26px;
  height: 26px;
}
.bold {
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 13px;
  color: rgba(131, 92, 242, 1);
}
</style>
